import { render } from "./SearchComponent.vue?vue&type=template&id=132ae848&scoped=true&ts=true"
import script from "./SearchComponent.vue?vue&type=script&lang=ts"
export * from "./SearchComponent.vue?vue&type=script&lang=ts"

import "./SearchComponent.vue?vue&type=style&index=0&id=132ae848&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132ae848"]])

export default __exports__